// Pour une documentation complète sur API, incluant des exemples de code, allez sur http://wix.to/94BuAAs

$w.onReady(function () {

});

// BUTTON MOUSE IN
export function buttonMenuMen_mouseIn(event) {
	$w('#boxMen').show();//Add your code for this event here: 
	$w('#lineMen').show();

	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();
}

export function buttonMenuWomen_mouseIn(event) {
	$w('#boxWomen').show();
	$w('#lineWomen').show();//Add your code for this event here: 
	
	$w('#boxMen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();
}

export function buttonMenuKids_mouseIn(event) {
	$w('#boxKids').show();
	$w('#lineKids').show();//Add your code for this event here: 

	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();
}

export function buttonMenuSport_mouseIn(event) {
	$w('#boxSport').show();
	$w('#lineSport').show();//Add your code for this event here: 

	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxMerchandising').hide();
}

export function buttonMenuOutlet_mouseIn(event) {
	$w('#lineOutlet').show();//Add your code for this event here: 

	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();
}

export function buttonMenuMerchandising_mouseIn(event) {
	$w('#boxMerchandising').show();
	$w('#lineMerchandising').show();//Add your code for this event here: 

	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	
}

export function buttonMenuYourCollection_mouseIn(event) {
	$w('#lineYourCollection').show();//Add your code for this event here: 
	
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();
}



//BUTTON MOUSE OUT
export function buttonMenuMen_mouseOut(event) {
	$w('#lineMen').hide();//Add your code for this event here: 
}

export function buttonMenuWomen_mouseOut(event) {
	$w('#lineWomen').hide();//Add your code for this event here: 
}

export function buttonMenuKids_mouseOut(event) {
	$w('#lineKids').hide();//Add your code for this event here: 
}

export function buttonMenuSport_mouseOut(event) {
	$w('#lineSport').hide();//Add your code for this event here: 
}

export function buttonMenuOutlet_mouseOut(event) {
	$w('#lineOutlet').hide();//Add your code for this event here: 
}

export function buttonMenuMerchandising_mouseOut(event) {
	$w('#lineMerchandising').hide();//Add your code for this event here: 
}

export function buttonMenuYourCollection_mouseOut(event) {
	$w('#lineYourCollection').hide();//Add your code for this event here: 
}

//BOX MOUSE OUT
export function boxMen_mouseOut(event) {
//	$w('#boxMen').hide();//Add your code for this event here: 
	$w('#lineMen').hide();
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide(); 
}

export function boxWomen_mouseOut(event) {
//	$w('#boxWomen').hide();//Add your code for this event here: 
	$w('#lineWomen').hide();
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide(); 
}

export function boxKids_mouseOut(event) {
//	$w('#boxKids').hide();//Add your code for this event here: 
	$w('#lineKids').hide();//Add your code for this event here:
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide();  
}

export function boxSport_mouseOut(event) {
//	$w('#boxSport').hide();//Add your code for this event here: 
	$w('#lineSport').hide();//Add your code for this event here: 
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide(); 
}

export function boxMerchandising_mouseOut(event) {
//	$w('#boxMerchandising').hide();//Add your code for this event here: 
	$w('#lineMerchandising').hide();//Add your code for this event here:
	$w('#boxMen').hide();
	$w('#boxWomen').hide();
	$w('#boxKids').hide();
	$w('#boxSport').hide();
	$w('#boxMerchandising').hide(); 
}


